module.exports = __webpack_public_path__ + "img/auth-form-header-bg.1a85c4db.png";